function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  fill: "#FFF1D6"
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 24,
  cy: 24.857,
  r: 13.429,
  stroke: "#FF7663",
  strokeWidth: 4
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#FF7663",
  strokeWidth: 4,
  d: "M13.659 13.892l19.837 19.837"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.193 31.714c1.237 0 2.452-.22 3.422-.615 2.312-.95 3.267-2.597 4.223-5.29.03-.073.052-.154.081-.234.23-.666.541-1.573.97-1.756.186-.08.356-.132.52-.146l.17-.008.17.007c.163.015.334.066.519.147.422.19.74 1.097.97 1.756.03.08.052.16.082.234.955 2.7 1.91 4.34 4.222 5.29.963.395 2.178.615 3.422.615h.015c2.09 0 3.986-.607 4.941-1.58.674-.688 1.134-1.61 1.445-2.913.089-.38.148-.82.207-1.28l.015-.14c.163-1.28.445-3.124 1.408-3.555l.148-2.144-.126-.022c-1.919-.322-3.652-.146-5.104-.146-.415 0-.83.007-1.222.007-.356 0-.712.007-1.052.007-1.815 0-3.475.168-4.934.49-.644.14-1.267.344-1.874.542-.904.293-1.837.593-2.77.673a4.659 4.659 0 01-.327.015h-.333c-.111 0-.222-.008-.333-.015-.934-.08-1.867-.38-2.77-.673-.608-.198-1.23-.403-1.875-.542-1.46-.322-3.126-.49-4.934-.49h-.822c-.326 0-.652-.007-.985-.007-1.682 0-3.556-.168-5.6.175l-.09.015.186 2.093c.948.424 1.222 2.246 1.378 3.505l.03.205c.058.46.11.9.207 1.28.31 1.302.77 2.232 1.444 2.912.963.973 2.852 1.58 4.941 1.58h.015v.008z",
  clipRule: "evenodd",
  fill: "#000",
  fillRule: "evenodd"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.193 31.495c1.237 0 2.452-.22 3.422-.615 2.312-.95 3.267-2.597 4.223-5.29.03-.073.052-.154.081-.234.23-.666.541-1.573.97-1.756.186-.08.356-.132.52-.146l.17-.008.17.007c.163.015.334.066.519.147.422.19.74 1.097.97 1.756.03.08.052.16.082.234.955 2.7 1.91 4.34 4.222 5.29.963.396 2.178.615 3.422.615h.015c2.09 0 3.986-.607 4.941-1.58.674-.688 1.134-1.61 1.445-2.913.089-.38.148-.82.207-1.28l.015-.14c.14-1.28.34-2.875 1.311-3.306l.082-.037.015-.14c.089-.943.14-1.572.148-1.872v-.125l-.126-.022c-1.919-.322-3.652-.365-5.104-.365-.415 0-.83.007-1.222.007-.356 0-.712.007-1.052.007-1.815 0-3.475.168-4.934.49-.644.14-1.267.344-1.874.542-.904.293-1.837.593-2.77.673a4.653 4.653 0 01-.327.015h-.333c-.111 0-.222-.008-.333-.015-.934-.08-1.867-.38-2.77-.673-.608-.198-1.23-.403-1.875-.542-1.46-.322-3.126-.49-4.934-.49h-.822c-.326 0-.652-.007-.985-.007-1.682 0-3.519.044-5.57.388l-.127.022v.124c.008.41.111 1.324.156 1.712.007.08.015.14.015.168l.007.088.081.037c.949.424 1.141 1.99 1.304 3.249l.037.204c.06.461.111.9.208 1.281.31 1.302.77 2.232 1.444 2.912.963.973 2.852 1.58 4.941 1.58h.015v.008z",
  clipRule: "evenodd",
  fill: "#706F6F",
  fillRule: "evenodd"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.148 20.256c2.786-.468 5.178-.38 7.349-.38 1.8 0 3.452.168 4.904.49.63.139 1.252.344 1.86.541.91.293 1.851.6 2.8.68.148.015.296.023.444.023h.133c.148 0 .297-.008.445-.022.948-.08 1.889-.388 2.8-.68a22.21 22.21 0 011.86-.542c1.451-.322 3.103-.483 4.903-.49 2.156 0 4.563-.118 7.349.343-.008.49-.141 1.764-.156 1.925-1.081.483-1.266 2.239-1.43 3.556-.066.454-.118.893-.207 1.259-.304 1.273-.755 2.18-1.407 2.846-.934.944-2.786 1.536-4.838 1.536-1.222 0-2.422-.212-3.37-.6-2.26-.929-3.2-2.546-4.141-5.202a4.373 4.373 0 00-.082-.234c-.252-.725-.563-1.632-1.052-1.844a1.795 1.795 0 00-.71-.168h-.075c-.222 0-.46.058-.711.168-.482.212-.8 1.12-1.052 1.844-.03.08-.052.16-.081.234-.941 2.656-1.882 4.273-4.141 5.202-.949.388-2.149.608-3.371.6-2.052 0-3.904-.592-4.837-1.536-.652-.666-1.104-1.566-1.408-2.846-.089-.374-.14-.805-.2-1.266-.17-1.317-.333-3.088-1.415-3.571-.007-.154-.155-1.376-.163-1.866z",
  clipRule: "evenodd",
  fill: "#161614",
  fillRule: "evenodd"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.327 25.634c.511 2.173 1.304 3.644 3.126 4.566 2.874 1.449 6.356.893 8.045-1.046a.741.741 0 00.096-.117 4.06 4.06 0 00.17-.227c.038-.052.075-.11.112-.161.83-1.303 1.66-4.332.815-6.169-.726-1.573-2.6-2.012-5.126-2.129-2.156-.102-4.571.168-6.067 1.04-.038.021-.067.036-.104.058a3.4 3.4 0 00-.645.497 2.41 2.41 0 00-.607.959c-.296.922.007 1.983.185 2.729zM9.26 28.7c1.407 2.202 5.066 3.19 8.355 1.602a5.303 5.303 0 002.127-1.814c.592-.856.985-1.91 1.244-3.147.918-4.28-2.393-4.814-6.467-5.005-1.94-.087-3.8.19-4.97.923-.082.05-.164.11-.238.16a2.82 2.82 0 00-.592.593c-1.178 1.654-.437 5.159.54 6.688z",
  clipRule: "evenodd",
  fill: "#000",
  fillRule: "evenodd"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.311 21.419c1.749 2.378 4.778 4.705 8.571 6.344.622.27 1.245.512 1.867.724.593-.856.985-1.91 1.244-3.146.92-4.28-2.392-4.815-6.467-5.005-1.94-.088-3.8.19-4.97.922-.09.051-.17.11-.245.161zm17.446.527c1.793 2.188 4.652 4.303 8.164 5.817.955.41 1.91.761 2.844 1.046.037-.05.074-.11.111-.16.83-1.303 1.66-4.332.815-6.169-.726-1.573-2.6-2.012-5.126-2.13-2.156-.102-4.57.17-6.067 1.04-.037.022-.067.036-.104.058-.237.147-.46.315-.637.498z",
  clipRule: "evenodd",
  fill: "#fff",
  fillRule: "evenodd",
  opacity: 0.3
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.644 20.563l.052.059-.207.073.155-.132z",
  fill: "#F3FEFF"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.83 20.636l-.163.117.03-.132.133.015z",
  fill: "#F6FFFF"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.615 20.878l.007.198-.089-.183.082-.015z",
  fill: "#F4FFFF"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.489 20.695l.126.183-.082.015-.044-.198z",
  fill: "#E6F1FF"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.667 20.753l-.052.124-.126-.182.178.058z",
  fill: "#DAE5FF"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.667 20.753l.066.183-.118-.059.052-.124z",
  fill: "#fff"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.733 20.936l-.11.139-.008-.198.118.059z",
  fill: "#DEE8FF"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.83 21.024l-.208.051.111-.139.097.088z",
  fill: "#CDD7FF"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.933 20.936l-.103.088-.097-.088h.2z",
  fill: "#F4FFFF"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.83 21.024v.073l-.208-.022.208-.051z",
  fill: "#fff"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.037 21.075l-.207.022v-.073l.207.051z",
  fill: "#F4FFFF"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.933 20.936l.104.14-.207-.052.103-.088zm.193-.044l-.089.183.015-.198.074.015z",
  fill: "#fff"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.052 20.878l-.015.198-.104-.14.119-.058z",
  fill: "#D2DCFF"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7 20.753l.052.124-.119.059.067-.183z",
  fill: "#E2EDFF"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.17 20.695l-.044.198-.074-.015.118-.183z",
  fill: "#F4FFFF"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.963 20.622l.037.132-.17-.117.133-.015z",
  fill: "#E2EDFF"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.17 20.695l-.118.183L7 20.754l.17-.052v-.007z",
  fill: "#fff"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.17 20.695l-.17.059-.007-.008-.03-.124.207.073z",
  fill: "#fff"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.17 20.695l-.207-.073.052-.059.155.132z",
  fill: "#DCE7FF"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.015 20.563l-.052.059-.133-.162.185.103z",
  fill: "#fff"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.83 20.461l-.134.161.134.015.133-.015-.133-.161z",
  fill: "#EEF8FF"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.696 20.622l-.051-.059.185-.102-.134.161zm0 0l-.03.132-.177-.059.207-.073z",
  fill: "#fff"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.993 20.746l.007.007-.067.183h-.2l-.066-.183.163-.117.163.11z",
  fill: "#E6F1FF"
});

var _ref33 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.6
}, React.createElement("path", {
  d: "M6.74 20.673l.023.03-.104.036.082-.066z",
  fill: "#F3FEFF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M6.83 20.709l-.082.059.015-.066.067.007z",
  fill: "#F6FFFF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M6.719 20.826l.007.102-.044-.095.037-.007z",
  fill: "#F4FFFF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M6.66 20.739l.059.088-.037.007-.023-.095z",
  fill: "#E6F1FF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M6.748 20.768l-.03.059-.059-.088.09.029z",
  fill: "#DAE5FF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M6.748 20.768l.037.088-.066-.03.03-.058z",
  fill: "#fff",
  opacity: 0.6
}), React.createElement("path", {
  d: "M6.785 20.856l-.059.073-.007-.102.066.029z",
  fill: "#DEE8FF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M6.83 20.9l-.104.03.06-.074.044.044z",
  fill: "#CDD7FF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M6.881 20.856l-.051.044-.045-.044h.096z",
  fill: "#F4FFFF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M6.83 20.9v.036l-.104-.007.104-.029z",
  fill: "#fff",
  opacity: 0.6
}), React.createElement("path", {
  d: "M6.933 20.929l-.103.007V20.9l.103.029z",
  fill: "#F4FFFF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M6.882 20.856l.051.073-.103-.03.052-.043zm.096-.022l-.045.095.008-.102.037.007z",
  fill: "#fff",
  opacity: 0.6
}), React.createElement("path", {
  d: "M6.94 20.826l-.007.102-.051-.073.059-.029z",
  fill: "#D2DCFF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M6.911 20.768l.03.059-.06.029.03-.088z",
  fill: "#E2EDFF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M7 20.739l-.022.095-.037-.007.06-.088z",
  fill: "#F4FFFF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M6.896 20.702l.015.066-.081-.059.066-.007z",
  fill: "#E2EDFF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M7 20.739l-.06.088-.029-.059.09-.029z",
  fill: "#fff",
  opacity: 0.6
}), React.createElement("path", {
  d: "M7 20.739l-.089.03-.015-.067.104.037z",
  fill: "#fff",
  opacity: 0.6
}), React.createElement("path", {
  d: "M7 20.739l-.104-.037.03-.029.074.066z",
  fill: "#DCE7FF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M6.926 20.673l-.03.03-.066-.081.096.051z",
  fill: "#fff",
  opacity: 0.6
}), React.createElement("path", {
  d: "M6.83 20.622l-.067.08.067.008.066-.007-.066-.081z",
  fill: "#EEF8FF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M6.763 20.702l-.022-.03.089-.05-.067.08z",
  fill: "#fff",
  opacity: 0.6
}), React.createElement("path", {
  d: "M6.763 20.702l-.015.066-.089-.03.104-.036z",
  fill: "#fff",
  opacity: 0.6
}), React.createElement("path", {
  d: "M6.911 20.768l-.03.088h-.096l-.037-.088.082-.059.081.059z",
  fill: "#E6F1FF",
  opacity: 0.6
}));

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.785 20.724l.008.015-.052.022.044-.037z",
  fill: "#F3FEFF"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.83 20.739l-.045.037.008-.037h.037z",
  fill: "#F6FFFF"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.77 20.804l.008.051-.022-.044.014-.007z",
  fill: "#F4FFFF"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.74 20.761l.03.044-.014.007-.015-.051z",
  fill: "#E6F1FF"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.785 20.775l-.015.03-.03-.045.045.015z",
  fill: "#DAE5FF"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.785 20.775l.022.044-.037-.015.015-.029z",
  fill: "#fff"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.807 20.819l-.03.037-.007-.052.037.015z",
  fill: "#DEE8FF"
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.83 20.848l-.052.007.03-.036.022.029z",
  fill: "#CDD7FF"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.86 20.819l-.03.03-.023-.03h.052z",
  fill: "#F4FFFF"
});

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.83 20.848v.015l-.052-.008.052-.007z",
  fill: "#fff"
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.889 20.856l-.06.007v-.014l.06.007z",
  fill: "#F4FFFF"
});

var _ref45 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.86 20.819l.029.037-.06-.008.03-.029z",
  fill: "#fff"
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.911 20.812l-.022.044v-.051l.022.007z",
  fill: "#fff"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.889 20.804v.051l-.03-.036.03-.015z",
  fill: "#D2DCFF"
});

var _ref48 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.874 20.775l.015.03-.03.014.015-.044z",
  fill: "#E2EDFF"
});

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.919 20.761l-.008.051-.022-.007.03-.044z",
  fill: "#F4FFFF"
});

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.867 20.739l.007.037-.044-.037h.037z",
  fill: "#E2EDFF"
});

var _ref51 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.919 20.761l-.03.044-.015-.03.045-.014z",
  fill: "#fff"
});

var _ref52 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.919 20.761l-.045.015-.007-.037.052.022z",
  fill: "#fff"
});

var _ref53 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.919 20.761l-.052-.022.015-.015.037.037z",
  fill: "#DCE7FF"
});

var _ref54 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.881 20.724l-.014.015-.037-.044.051.029z",
  fill: "#fff"
});

var _ref55 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.83 20.695l-.037.044h.074l-.037-.044z",
  fill: "#EEF8FF"
});

var _ref56 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.793 20.739l-.008-.015.045-.029-.037.044zm0 0l-.008.037-.044-.015.052-.022z",
  fill: "#fff"
});

var _ref57 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.874 20.775l-.015.044h-.052l-.022-.044.045-.037.044.037z",
  fill: "#E6F1FF"
});

var _ref58 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.808 20.753l.007.007-.03.008.023-.015z",
  fill: "#F3FEFF"
});

var _ref59 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.83 20.761l-.023.015.008-.015h.015z",
  fill: "#F6FFFF"
});

var _ref60 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.8 20.79v.03l-.007-.023.007-.007z",
  fill: "#F4FFFF"
});

var _ref61 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.785 20.768l.015.022-.007.007-.008-.029z",
  fill: "#E6F1FF"
});

var _ref62 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.808 20.775l-.008.015-.015-.022.022.007z",
  fill: "#DAE5FF"
});

var _ref63 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.808 20.775l.007.03-.015-.015.008-.015z",
  fill: "#fff"
});

var _ref64 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.815 20.804l-.015.015v-.03l.015.015z",
  fill: "#DEE8FF"
});

var _ref65 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.83 20.812l-.03.007.015-.014.015.007z",
  fill: "#CDD7FF"
});

var _ref66 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.845 20.804l-.015.007-.015-.007h.03z",
  fill: "#F4FFFF"
});

var _ref67 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.83 20.812v.015l-.03-.008.03-.007z",
  fill: "#fff"
});

var _ref68 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.86 20.819l-.03.007v-.014l.03.007z",
  fill: "#F4FFFF"
});

var _ref69 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.845 20.804l.014.015-.03-.008.016-.007zm.029-.007l-.015.022v-.03l.015.008z",
  fill: "#fff"
});

var _ref70 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.86 20.79v.03l-.016-.015.015-.015z",
  fill: "#D2DCFF"
});

var _ref71 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.852 20.775l.007.015-.015.014.008-.029z",
  fill: "#E2EDFF"
});

var _ref72 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.874 20.768v.03l-.015-.008.015-.022z",
  fill: "#F4FFFF"
});

var _ref73 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.852 20.761v.015l-.022-.015h.022z",
  fill: "#E2EDFF"
});

var _ref74 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.874 20.768l-.015.022-.007-.015.022-.007z",
  fill: "#fff"
});

var _ref75 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.874 20.768l-.022.007v-.014l.022.007z",
  fill: "#fff"
});

var _ref76 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.874 20.768l-.022-.007.007-.008.015.015z",
  fill: "#DCE7FF"
});

var _ref77 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.86 20.753l-.008.007-.022-.022.03.015z",
  fill: "#fff"
});

var _ref78 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.83 20.739l-.015.022h.037l-.022-.022z",
  fill: "#EEF8FF"
});

var _ref79 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.815 20.761l-.008-.007.023-.015-.015.022zm0 0l-.008.015-.022-.008.03-.007z",
  fill: "#fff"
});

var _ref80 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.852 20.775l-.008.03h-.03l-.007-.03.023-.015.022.015z",
  fill: "#E6F1FF"
});

var _ref81 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.993 20.746l.007.007-.067.183h-.2l-.066-.183.163-.117.163.11z",
  fill: "url(#ex)",
  opacity: 0.5
});

var _ref82 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.2
}, React.createElement("path", {
  d: "M6.83 20.783l.015-.22H6.83v.22z",
  fill: "url(#ck)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l.052-.212h-.008l-.007-.007-.037.219z",
  fill: "url(#bz)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l.089-.205h-.015l-.074.205z",
  fill: "url(#bo)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l.118-.183v-.007h-.007l-.111.19z",
  fill: "url(#bd)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l.148-.161v-.007H6.97l-.14.168z",
  fill: "url(#as)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l.177-.132L7 20.644v-.007l-.17.146z",
  fill: "url(#ah)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l.2-.102-.008-.008-.192.11z",
  fill: "url(#w)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l.215-.066-.008-.007v-.007l-.207.08z",
  fill: "url(#l)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l.222-.03v-.007l-.007-.007-.215.044z",
  fill: "url(#a)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l.222.007v-.014l-.222.007z",
  fill: "url(#em)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l.215.044v-.007l-.215-.037z",
  fill: "url(#eb)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l.207.08v-.007l-.207-.073z",
  fill: "url(#dq)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l.185.117.007-.007v-.008l-.192-.102z",
  fill: "url(#df)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l.163.146.007-.007-.17-.139z",
  fill: "url(#cu)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l.133.168h.007l.008-.007-.148-.161z",
  fill: "url(#cp)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l.103.19h.008v-.007l-.111-.183z",
  fill: "url(#co)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l.066.205h.008l.007-.007-.081-.198z",
  fill: "url(#cn)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l.03.212h.014l-.044-.212z",
  fill: "url(#cm)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l-.008.212h.015l-.007-.212z",
  fill: "url(#cl)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l-.045.212h.008l.037-.212z",
  fill: "url(#cj)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l-.082.198h.008v.007l.074-.205z",
  fill: "url(#ci)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l-.119.183h.007l.008.007.104-.19z",
  fill: "url(#ch)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l-.149.154.008.007v.007l.14-.168z",
  fill: "url(#cg)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l-.17.132.007.007.163-.139z",
  fill: "url(#cf)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l-.193.095v.007l.007.008.186-.11z",
  fill: "url(#ce)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l-.208.059v.014l.208-.073z",
  fill: "url(#cd)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l-.215.022v.015l.215-.037z",
  fill: "url(#cc)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l-.215-.015v.015h.215z",
  fill: "url(#cb)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l-.215-.051v.014l.215.037z",
  fill: "url(#ca)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l-.2-.088v.007l-.008.008.208.073z",
  fill: "url(#by)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l-.186-.117-.007.007.193.11z",
  fill: "url(#bx)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l-.156-.146h-.007l-.008.007.17.139z",
  fill: "url(#bw)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l-.134-.176v.008H6.69l.14.168z",
  fill: "url(#bv)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l-.097-.198-.007.008h-.008l.112.19z",
  fill: "url(#bu)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l-.06-.212-.007.007h-.007l.074.205z",
  fill: "url(#bt)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M6.83 20.783l-.023-.22H6.8l-.007.008.037.212z",
  fill: "url(#bs)",
  opacity: 0.2
}));

var _ref83 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7 20.753l-.067.183-.2-.234.097-.066.163.11.007.007z",
  fill: "#fff",
  opacity: 0.2
});

var _ref84 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.6
}, React.createElement("path", {
  d: "M6.948 20.717c-.015.022-.007.051.022.073.023.015.06.015.074-.007.015-.022.008-.051-.022-.073a.058.058 0 00-.074.007z",
  fill: "url(#br)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M7.03 20.526c-.008 0-.023.11-.037.241-.015.132-.015.125-.023.183-.007.066.015-.044.037-.183.015-.131.03-.241.023-.241z",
  fill: "url(#bq)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M6.77 20.724c0 .007.112.022.245.036.133.015.126.008.185.015.067.008-.052-.014-.185-.03s-.245-.028-.245-.021z",
  fill: "url(#bp)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M6.911 20.812s.045-.022.097-.059.088-.065.088-.065-.044.022-.088.058a.468.468 0 00-.097.066z",
  fill: "url(#bn)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M6.933 20.658s.023.044.06.095.066.088.066.088-.022-.044-.059-.095a1.165 1.165 0 01-.067-.088z",
  fill: "url(#bm)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M6.933 20.746c0 .015.023.022.06.03s.066 0 .066-.015-.022-.022-.059-.03-.06 0-.067.015z",
  fill: "url(#bl)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M6.985 20.812c.008 0 .03-.022.037-.059s.008-.065-.007-.065c-.008 0-.03.022-.037.058s-.008.066.007.066z",
  fill: "url(#bk)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M6.978 20.768c0 .007.015 0 .03-.007.014-.008.022-.022.014-.022 0-.008-.015 0-.03.007-.014.007-.022.015-.014.022z",
  fill: "url(#bj)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M6.978 20.731c-.008 0 0 .015.007.03.008.014.022.021.022.014.008 0 0-.015-.007-.03-.007-.014-.015-.021-.022-.014z",
  fill: "url(#bi)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M7.082 20.695a.106.106 0 00-.141-.03c-.045.03-.06.096-.022.14.03.044.096.058.14.029s.052-.095.023-.139z",
  fill: "url(#bh)",
  opacity: 0.57
}));

var _ref85 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.8
}, React.createElement("path", {
  d: "M6.815 20.585c-.022.007-.037.037-.022.059.007.029.037.044.059.036.022-.007.037-.036.022-.058a.049.049 0 00-.06-.037z",
  fill: "url(#bg)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M6.97 20.49s-.075.066-.156.154-.074.08-.111.124c-.045.044.037-.022.118-.11.09-.095.156-.168.149-.168z",
  fill: "url(#bf)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M6.681 20.497s.067.073.156.154.082.073.126.11c.044.043-.03-.037-.119-.118-.081-.087-.155-.153-.163-.146z",
  fill: "url(#be)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M6.733 20.629s.045.007.097.007h.096s-.044-.007-.096-.007h-.097z",
  fill: "url(#bc)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M6.837 20.534s-.007.044-.007.095v.095s.007-.044.007-.095v-.095z",
  fill: "url(#bb)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M6.793 20.592c-.008.007.007.03.03.051.022.022.044.03.051.022s-.007-.03-.03-.051c-.022-.015-.044-.03-.051-.022z",
  fill: "url(#ba)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M6.793 20.673c.007.007.03 0 .052-.022s.037-.044.03-.051-.03 0-.053.022c-.022.022-.037.044-.03.051z",
  fill: "url(#az)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M6.808 20.636c0 .007.007.007.022.007s.022 0 .022-.007-.007-.007-.022-.007c-.008-.008-.023 0-.023.007z",
  fill: "url(#ay)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M6.83 20.607c-.008 0-.008.015-.008.022 0 .014.008.022.008.022.007 0 .007-.015.007-.022s0-.022-.007-.022z",
  fill: "url(#ax)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M6.926 20.636c0-.051-.037-.088-.089-.095a.085.085 0 00-.089.088c0 .05.037.087.09.095a.09.09 0 00.088-.088z",
  fill: "url(#aw)",
  opacity: 0.57
}));

var _ref86 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.8
}, React.createElement("path", {
  d: "M6.615 20.783c-.022.007-.037.037-.022.059.007.029.037.043.059.036s.037-.037.022-.058a.049.049 0 00-.06-.037z",
  fill: "url(#av)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M6.77 20.688s-.074.066-.156.154c-.081.087-.074.08-.111.124-.045.044.037-.022.118-.11.09-.095.156-.168.149-.168z",
  fill: "url(#au)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M6.481 20.695s.067.073.156.154c.089.08.082.073.126.11.044.043-.03-.037-.119-.118a.86.86 0 00-.163-.146z",
  fill: "url(#at)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M6.533 20.834s.045.007.097.007h.096s-.044-.007-.096-.007c-.052-.007-.097-.007-.097 0z",
  fill: "url(#ar)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M6.637 20.731s-.007.044-.007.095v.095s.007-.044.007-.095v-.095z",
  fill: "url(#aq)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M6.593 20.797c-.008.007.007.03.03.051.021.022.044.03.051.022s-.007-.03-.03-.051c-.022-.022-.044-.03-.051-.022z",
  fill: "url(#ap)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M6.593 20.87c.007.007.03 0 .051-.022.023-.022.038-.044.03-.051-.007-.007-.03 0-.052.022s-.037.044-.03.051z",
  fill: "url(#ao)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M6.607 20.834c0 .007.008.007.023.007s.022 0 .022-.007-.007-.007-.022-.007-.023 0-.023.007z",
  fill: "url(#an)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M6.63 20.804c-.008 0-.008.015-.008.022 0 .015.008.022.008.022.007 0 .007-.015.007-.022s0-.022-.007-.022z",
  fill: "url(#am)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M6.719 20.834c0-.051-.037-.088-.09-.095-.051 0-.088.037-.088.088s.037.088.089.095a.085.085 0 00.089-.088z",
  fill: "url(#al)",
  opacity: 0.57
}));

var _ref87 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.6
}, React.createElement("path", {
  d: "M6.926 20.892c-.015 0-.03.022-.03.044s.015.037.037.037c.015 0 .03-.022.03-.044 0-.015-.015-.037-.037-.037z",
  fill: "url(#ak)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M7.067 20.856s-.067.037-.156.08c-.081.044-.074.044-.111.066-.044.022.037-.007.119-.058a.832.832 0 00.148-.088z",
  fill: "url(#aj)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M6.852 20.797l.081.146c.045.08.045.073.067.11l-.06-.117a3.972 3.972 0 00-.088-.139z",
  fill: "url(#ai)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M6.86 20.914s.029.015.073.022c.037.015.074.022.074.022s-.03-.015-.074-.022c-.044-.015-.074-.03-.074-.022z",
  fill: "url(#ag)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M6.956 20.863s-.015.03-.03.073c-.015.037-.022.073-.022.073s.015-.029.03-.073l.022-.073z",
  fill: "url(#af)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M6.911 20.9c-.007.007 0 .022.008.044.014.022.03.037.037.03s0-.023-.008-.045c-.015-.022-.03-.036-.037-.029z",
  fill: "url(#ae)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M6.889 20.951c0 .007.022.007.044-.007.023-.008.037-.022.037-.03s-.022-.007-.044.008c-.022.007-.037.022-.037.029z",
  fill: "url(#ad)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M6.911 20.929l.015.015h.022l-.015-.015h-.022z",
  fill: "url(#ac)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M6.933 20.914l-.015.015v.022l.015-.015c.007-.007.008-.022 0-.022z",
  fill: "url(#ab)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M7 20.958c.015-.037-.007-.073-.044-.088s-.074.007-.09.044c-.014.037.008.073.045.088s.074-.007.09-.044z",
  fill: "url(#aa)",
  opacity: 0.57
}));

var _ref88 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.128 20.563l.052.059-.207.073.155-.132z",
  fill: "#F3FEFF"
});

var _ref89 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.313 20.636l-.163.117.03-.132.133.015z",
  fill: "#F6FFFF"
});

var _ref90 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.098 20.878l.007.198-.089-.183.082-.015z",
  fill: "#F4FFFF"
});

var _ref91 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.972 20.695l.126.183-.082.015-.044-.198z",
  fill: "#E6F1FF"
});

var _ref92 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.15 20.753l-.052.124-.126-.182.178.058z",
  fill: "#DAE5FF"
});

var _ref93 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.15 20.753l.067.183-.119-.059.052-.124z",
  fill: "#fff"
});

var _ref94 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.217 20.936l-.111.139-.008-.198.119.059z",
  fill: "#DEE8FF"
});

var _ref95 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.313 21.024l-.207.051.11-.139.097.088z",
  fill: "#CDD7FF"
});

var _ref96 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.417 20.936l-.104.088-.096-.088h.2z",
  fill: "#F4FFFF"
});

var _ref97 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.313 21.024v.073l-.207-.022.207-.051z",
  fill: "#fff"
});

var _ref98 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.521 21.075l-.207.022v-.073l.207.051z",
  fill: "#F4FFFF"
});

var _ref99 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.417 20.936l.104.14-.208-.052.104-.088zm.193-.044l-.089.183.015-.198.074.015z",
  fill: "#fff"
});

var _ref100 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.536 20.878l-.015.198-.104-.14.119-.058z",
  fill: "#D2DCFF"
});

var _ref101 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.484 20.753l.052.124-.119.059.067-.183z",
  fill: "#E2EDFF"
});

var _ref102 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.654 20.695l-.044.198-.074-.015.118-.183z",
  fill: "#F4FFFF"
});

var _ref103 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.446 20.622l.037.132-.17-.117.133-.015z",
  fill: "#E2EDFF"
});

var _ref104 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.654 20.695l-.118.183-.052-.124.17-.052v-.007z",
  fill: "#fff"
});

var _ref105 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.654 20.695l-.17.059-.008-.008-.03-.124.208.073z",
  fill: "#fff"
});

var _ref106 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.654 20.695l-.207-.073.051-.059.156.132z",
  fill: "#DCE7FF"
});

var _ref107 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.498 20.563l-.052.059-.133-.162.185.103z",
  fill: "#fff"
});

var _ref108 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.313 20.461l-.133.161.133.015.133-.015-.133-.161z",
  fill: "#EEF8FF"
});

var _ref109 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.18 20.622l-.052-.059.185-.102-.133.161zm0 0l-.03.132-.177-.059.207-.073z",
  fill: "#fff"
});

var _ref110 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.476 20.746l.007.007-.066.183h-.2l-.067-.183.163-.117.163.11z",
  fill: "#E6F1FF"
});

var _ref111 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.6
}, React.createElement("path", {
  d: "M40.224 20.673l.022.03-.104.036.082-.066z",
  fill: "#F3FEFF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M40.313 20.709l-.082.059.015-.066.067.007z",
  fill: "#F6FFFF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M40.202 20.826l.007.102-.044-.095.037-.007z",
  fill: "#F4FFFF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M40.143 20.739l.06.088-.038.007-.022-.095z",
  fill: "#E6F1FF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M40.232 20.768l-.03.059-.059-.088.089.029z",
  fill: "#DAE5FF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M40.232 20.768l.037.088-.067-.03.03-.058z",
  fill: "#fff",
  opacity: 0.6
}), React.createElement("path", {
  d: "M40.269 20.856l-.06.073-.007-.102.067.029z",
  fill: "#DEE8FF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M40.313 20.9l-.104.03.06-.074.044.044z",
  fill: "#CDD7FF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M40.365 20.856l-.052.044-.044-.044h.096z",
  fill: "#F4FFFF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M40.313 20.9v.036l-.104-.007.104-.029z",
  fill: "#fff",
  opacity: 0.6
}), React.createElement("path", {
  d: "M40.417 20.929l-.104.007V20.9l.104.029z",
  fill: "#F4FFFF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M40.365 20.856l.052.073-.104-.03.052-.043zm.096-.022l-.044.095.007-.102.037.007z",
  fill: "#fff",
  opacity: 0.6
}), React.createElement("path", {
  d: "M40.424 20.826l-.007.102-.052-.073.059-.029z",
  fill: "#D2DCFF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M40.395 20.768l.03.059-.06.029.03-.088z",
  fill: "#E2EDFF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M40.484 20.739l-.022.095-.037-.007.059-.088z",
  fill: "#F4FFFF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M40.38 20.702l.015.066-.082-.059.067-.007z",
  fill: "#E2EDFF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M40.484 20.739l-.06.088-.029-.059.089-.029z",
  fill: "#fff",
  opacity: 0.6
}), React.createElement("path", {
  d: "M40.484 20.739l-.089.03-.015-.067.104.037z",
  fill: "#fff",
  opacity: 0.6
}), React.createElement("path", {
  d: "M40.484 20.739l-.104-.037.03-.029.074.066z",
  fill: "#DCE7FF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M40.41 20.673l-.03.03-.066-.081.096.051z",
  fill: "#fff",
  opacity: 0.6
}), React.createElement("path", {
  d: "M40.313 20.622l-.067.08.067.008.067-.007-.067-.081z",
  fill: "#EEF8FF",
  opacity: 0.6
}), React.createElement("path", {
  d: "M40.246 20.702l-.022-.03.089-.05-.067.08z",
  fill: "#fff",
  opacity: 0.6
}), React.createElement("path", {
  d: "M40.246 20.702l-.015.066-.089-.03.104-.036z",
  fill: "#fff",
  opacity: 0.6
}), React.createElement("path", {
  d: "M40.395 20.768l-.03.088h-.096l-.037-.088.082-.059.081.059z",
  fill: "#E6F1FF",
  opacity: 0.6
}));

var _ref112 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.269 20.724l.007.015-.051.022.044-.037z",
  fill: "#F3FEFF"
});

var _ref113 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.313 20.739l-.044.037.007-.037h.037z",
  fill: "#F6FFFF"
});

var _ref114 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.254 20.804l.007.051-.022-.044.015-.007z",
  fill: "#F4FFFF"
});

var _ref115 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.224 20.761l.03.044-.015.007-.015-.051z",
  fill: "#E6F1FF"
});

var _ref116 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.269 20.775l-.015.03-.03-.045.045.015z",
  fill: "#DAE5FF"
});

var _ref117 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.269 20.775l.022.044-.037-.015.015-.029z",
  fill: "#fff"
});

var _ref118 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.291 20.819l-.03.037-.007-.052.037.015z",
  fill: "#DEE8FF"
});

var _ref119 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.313 20.848l-.052.007.03-.036.022.029z",
  fill: "#CDD7FF"
});

var _ref120 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.343 20.819l-.03.03-.022-.03h.052z",
  fill: "#F4FFFF"
});

var _ref121 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.313 20.848v.015l-.052-.008.052-.007z",
  fill: "#fff"
});

var _ref122 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.372 20.856l-.06.007v-.014l.06.007z",
  fill: "#F4FFFF"
});

var _ref123 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.343 20.819l.03.037-.06-.008.03-.029zm.052-.007l-.022.044v-.051l.022.007z",
  fill: "#fff"
});

var _ref124 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.372 20.804v.051l-.03-.036.03-.015z",
  fill: "#D2DCFF"
});

var _ref125 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.358 20.775l.015.03-.03.014.015-.044z",
  fill: "#E2EDFF"
});

var _ref126 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.402 20.761l-.007.051-.023-.007.03-.044z",
  fill: "#F4FFFF"
});

var _ref127 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.35 20.739l.007.037-.044-.037h.037z",
  fill: "#E2EDFF"
});

var _ref128 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.402 20.761l-.03.044-.014-.03.044-.014z",
  fill: "#fff"
});

var _ref129 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.402 20.761l-.044.015-.008-.037.052.022z",
  fill: "#fff"
});

var _ref130 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.402 20.761l-.052-.022.015-.015.037.037z",
  fill: "#DCE7FF"
});

var _ref131 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.365 20.724l-.015.015-.037-.044.052.029z",
  fill: "#fff"
});

var _ref132 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.313 20.695l-.037.044h.074l-.037-.044z",
  fill: "#EEF8FF"
});

var _ref133 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.276 20.739l-.007-.015.044-.029-.037.044zm0 0l-.007.037-.045-.015.052-.022z",
  fill: "#fff"
});

var _ref134 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.358 20.775l-.015.044h-.052l-.022-.044.044-.037.045.037z",
  fill: "#E6F1FF"
});

var _ref135 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.291 20.753l.007.007-.03.008.023-.015z",
  fill: "#F3FEFF"
});

var _ref136 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.313 20.761l-.022.015.007-.015h.015z",
  fill: "#F6FFFF"
});

var _ref137 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.284 20.79v.03l-.007-.023.007-.007z",
  fill: "#F4FFFF"
});

var _ref138 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.269 20.768l.015.022-.008.007-.007-.029z",
  fill: "#E6F1FF"
});

var _ref139 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.291 20.775l-.007.015-.015-.022.022.007z",
  fill: "#DAE5FF"
});

var _ref140 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.291 20.775l.007.03-.014-.015.007-.015z",
  fill: "#fff"
});

var _ref141 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.298 20.804l-.015.015v-.03l.015.015z",
  fill: "#DEE8FF"
});

var _ref142 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.313 20.812l-.03.007.015-.014.015.007z",
  fill: "#CDD7FF"
});

var _ref143 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.328 20.804l-.015.007-.015-.007h.03z",
  fill: "#F4FFFF"
});

var _ref144 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.313 20.812v.015l-.03-.008.03-.007z",
  fill: "#fff"
});

var _ref145 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.343 20.819l-.03.007v-.014l.03.007z",
  fill: "#F4FFFF"
});

var _ref146 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.328 20.804l.015.015-.03-.008.015-.007z",
  fill: "#fff"
});

var _ref147 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.358 20.797l-.015.022v-.03l.015.008z",
  fill: "#fff"
});

var _ref148 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.343 20.79v.03l-.015-.015.015-.015z",
  fill: "#D2DCFF"
});

var _ref149 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.335 20.775l.007.015-.014.014.007-.029z",
  fill: "#E2EDFF"
});

var _ref150 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.358 20.768v.03l-.015-.008.015-.022z",
  fill: "#F4FFFF"
});

var _ref151 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.335 20.761v.015l-.022-.015h.022z",
  fill: "#E2EDFF"
});

var _ref152 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.358 20.768l-.015.022-.007-.015.022-.007z",
  fill: "#fff"
});

var _ref153 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.358 20.768l-.022.007v-.014l.022.007z",
  fill: "#fff"
});

var _ref154 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.358 20.768l-.022-.007.007-.008.015.015z",
  fill: "#DCE7FF"
});

var _ref155 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.343 20.753l-.007.007-.023-.022.03.015z",
  fill: "#fff"
});

var _ref156 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.313 20.739l-.015.022h.037l-.022-.022z",
  fill: "#EEF8FF"
});

var _ref157 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.298 20.761l-.007-.007.022-.015-.015.022zm0 0l-.007.015-.023-.008.03-.007z",
  fill: "#fff"
});

var _ref158 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.335 20.775l-.007.03h-.03l-.007-.03.022-.015.022.015z",
  fill: "#E6F1FF"
});

var _ref159 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.476 20.746l.007.007-.066.183h-.2l-.067-.183.163-.117.163.11z",
  fill: "url(#z)",
  opacity: 0.5
});

var _ref160 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.2
}, React.createElement("path", {
  d: "M40.313 20.783l.015-.22h-.015v.22z",
  fill: "url(#y)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l.052-.212h-.008l-.007-.007-.037.219z",
  fill: "url(#x)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l.089-.205h-.015l-.074.205z",
  fill: "url(#v)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l.118-.183v-.007h-.007l-.111.19z",
  fill: "url(#u)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l.148-.161v-.007h-.007l-.141.168z",
  fill: "url(#t)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l.178-.132-.008-.007v-.007l-.17.146z",
  fill: "url(#s)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l.2-.102-.007-.008-.193.11z",
  fill: "url(#r)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l.215-.066-.008-.007v-.007l-.207.08z",
  fill: "url(#q)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l.222-.03v-.007l-.007-.007-.215.044z",
  fill: "url(#p)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l.222.007v-.014l-.222.007z",
  fill: "url(#o)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l.215.044v-.007l-.215-.037z",
  fill: "url(#n)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l.207.08v-.007l-.207-.073z",
  fill: "url(#m)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l.185.117.008-.007v-.008l-.193-.102z",
  fill: "url(#k)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l.163.146.007-.007-.17-.139z",
  fill: "url(#j)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l.133.168h.008l.007-.007-.148-.161z",
  fill: "url(#i)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l.104.19h.007v-.007l-.111-.183z",
  fill: "url(#h)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l.067.205h.007l.007-.007-.081-.198z",
  fill: "url(#g)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l.03.212h.014l-.044-.212z",
  fill: "url(#f)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l-.007.212h.015l-.008-.212z",
  fill: "url(#e)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l-.044.212h.007l.037-.212z",
  fill: "url(#d)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l-.082.198h.008v.007l.074-.205z",
  fill: "url(#c)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l-.119.183h.008l.007.007.104-.19z",
  fill: "url(#b)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l-.148.154.007.007v.007l.141-.168z",
  fill: "url(#ew)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l-.17.132.007.007.163-.139z",
  fill: "url(#ev)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l-.193.095v.007l.008.008.185-.11z",
  fill: "url(#eu)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l-.207.059v.014l.207-.073z",
  fill: "url(#et)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l-.215.022v.015l.215-.037z",
  fill: "url(#es)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l-.215-.015v.015h.215z",
  fill: "url(#er)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l-.215-.051v.014l.215.037z",
  fill: "url(#eq)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l-.2-.088v.007l-.007.008.207.073z",
  fill: "url(#ep)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l-.185-.117-.008.007.193.11z",
  fill: "url(#eo)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l-.156-.146h-.007l-.007.007.17.139z",
  fill: "url(#en)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l-.133-.176v.008h-.008l.141.168z",
  fill: "url(#el)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l-.096-.198-.008.008h-.007l.111.19z",
  fill: "url(#ek)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l-.06-.212-.007.007h-.007l.074.205z",
  fill: "url(#ej)",
  opacity: 0.2
}), React.createElement("path", {
  d: "M40.313 20.783l-.022-.22h-.008l-.007.008.037.212z",
  fill: "url(#ei)",
  opacity: 0.2
}));

var _ref161 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.484 20.753l-.067.183-.2-.234.097-.066.163.11.007.007z",
  fill: "#fff",
  opacity: 0.2
});

var _ref162 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.6
}, React.createElement("path", {
  d: "M40.432 20.717c-.015.022-.007.051.022.073.022.015.06.015.074-.007.015-.022.008-.051-.022-.073a.058.058 0 00-.074.007z",
  fill: "url(#eh)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M40.513 20.526c-.007 0-.022.11-.037.241l-.022.183c-.008.066.015-.044.037-.183.015-.131.03-.241.022-.241z",
  fill: "url(#eg)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M40.254 20.724c0 .007.111.022.244.036.134.015.126.008.186.015.066.008-.052-.014-.185-.03-.134-.014-.245-.028-.245-.021z",
  fill: "url(#ef)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M40.395 20.812s.044-.022.096-.059l.09-.065s-.045.022-.09.058a.466.466 0 00-.096.066z",
  fill: "url(#ee)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M40.417 20.658s.022.044.06.095c.036.051.066.088.066.088s-.022-.044-.06-.095c-.036-.044-.066-.088-.066-.088z",
  fill: "url(#ed)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M40.417 20.746c0 .015.022.022.06.03.036.007.066 0 .066-.015s-.022-.022-.06-.03c-.036-.007-.059 0-.066.015z",
  fill: "url(#ec)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M40.469 20.812c.007 0 .03-.022.037-.059s.007-.065-.007-.065c-.008 0-.03.022-.037.058s-.008.066.007.066z",
  fill: "url(#ea)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M40.461 20.768c0 .007.015 0 .03-.007.007-.008.014-.022.014-.022 0-.008-.014 0-.03.007s-.022.015-.014.022z",
  fill: "url(#dz)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M40.461 20.731c-.007 0 0 .015.007.03.008.014.023.021.023.014.007 0 0-.015-.008-.03-.007-.014-.015-.021-.022-.014z",
  fill: "url(#dy)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M40.565 20.695a.106.106 0 00-.14-.03c-.045.03-.06.096-.023.14.03.044.096.058.14.029.045-.03.053-.095.023-.139z",
  fill: "url(#dx)",
  opacity: 0.57
}));

var _ref163 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.8
}, React.createElement("path", {
  d: "M40.298 20.585c-.022.007-.037.037-.022.059.007.029.037.044.059.036.022-.007.037-.036.022-.058-.007-.03-.037-.044-.059-.037z",
  fill: "url(#dw)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M40.453 20.49s-.074.066-.156.154-.074.08-.11.124c-.045.044.036-.022.118-.11.089-.095.155-.168.148-.168z",
  fill: "url(#dv)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M40.165 20.497s.067.073.155.154.082.073.127.11c.044.043-.03-.037-.12-.118-.08-.087-.155-.153-.162-.146z",
  fill: "url(#du)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M40.217 20.629s.044.007.096.007h.097s-.045-.007-.097-.007h-.096z",
  fill: "url(#dt)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M40.321 20.534s-.007.044-.007.095v.095s.007-.044.007-.095v-.095z",
  fill: "url(#ds)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M40.276 20.592c-.007.007.007.03.03.051.022.022.044.03.052.022s-.008-.03-.03-.051c-.022-.015-.045-.03-.052-.022z",
  fill: "url(#dr)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M40.276 20.673c.007.007.03 0 .052-.022s.037-.044.03-.051-.03 0-.052.022-.037.044-.03.051z",
  fill: "url(#dp)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M40.291 20.636c0 .007.007.007.022.007s.022 0 .022-.007-.007-.007-.022-.007c-.007-.008-.022 0-.022.007z",
  fill: "url(#do)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M40.313 20.607c-.007 0-.007.015-.007.022 0 .014.007.022.007.022.007 0 .007-.015.007-.022s0-.022-.007-.022z",
  fill: "url(#dn)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M40.41 20.636c0-.051-.037-.088-.089-.095a.085.085 0 00-.089.088c0 .05.037.087.09.095a.09.09 0 00.088-.088z",
  fill: "url(#dm)",
  opacity: 0.57
}));

var _ref164 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.8
}, React.createElement("path", {
  d: "M40.098 20.783c-.022.007-.037.037-.022.059.007.029.037.043.06.036s.036-.037.021-.058c-.007-.03-.037-.044-.059-.037z",
  fill: "url(#dl)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M40.253 20.688s-.074.066-.156.154-.074.08-.11.124c-.045.044.036-.022.118-.11.089-.095.155-.168.148-.168z",
  fill: "url(#dk)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M39.965 20.695s.067.073.155.154c.09.08.082.073.127.11.044.043-.03-.037-.119-.118a.86.86 0 00-.163-.146z",
  fill: "url(#dj)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M40.017 20.834s.044.007.096.007h.097s-.045-.007-.097-.007c-.051-.007-.096-.007-.096 0z",
  fill: "url(#di)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M40.12 20.731s-.007.044-.007.095v.095s.007-.044.007-.095v-.095z",
  fill: "url(#dh)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M40.076 20.797c-.007.007.007.03.03.051.022.022.044.03.051.022s-.007-.03-.03-.051c-.021-.022-.044-.03-.051-.022z",
  fill: "url(#dg)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M40.076 20.87c.007.007.03 0 .052-.022s.037-.044.03-.051c-.008-.007-.03 0-.052.022-.023.022-.037.044-.03.051z",
  fill: "url(#de)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M40.091 20.834c0 .007.007.007.022.007s.023 0 .023-.007-.008-.007-.023-.007-.022 0-.022.007z",
  fill: "url(#dd)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M40.113 20.804c-.007 0-.007.015-.007.022 0 .015.007.022.007.022.007 0 .007-.015.007-.022s0-.022-.007-.022z",
  fill: "url(#dc)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M40.202 20.834c0-.051-.037-.088-.089-.095-.052 0-.089.037-.089.088s.037.088.09.095a.085.085 0 00.088-.088z",
  fill: "url(#db)",
  opacity: 0.57
}));

var _ref165 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.6
}, React.createElement("path", {
  d: "M40.41 20.892c-.015 0-.03.022-.03.044s.015.037.037.037c.015 0 .03-.022.03-.044 0-.015-.015-.037-.037-.037z",
  fill: "url(#da)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M40.55 20.856s-.067.037-.155.08c-.082.044-.075.044-.112.066-.044.022.037-.007.119-.058a.83.83 0 00.148-.088z",
  fill: "url(#cz)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M40.335 20.797l.082.146c.044.08.044.073.066.11l-.06-.117c-.044-.073-.088-.139-.088-.139z",
  fill: "url(#cy)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M40.343 20.914s.03.015.074.022c.037.015.074.022.074.022s-.03-.015-.074-.022c-.044-.015-.074-.03-.074-.022z",
  fill: "url(#cx)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M40.439 20.863s-.015.03-.03.073c-.015.037-.022.073-.022.073s.015-.029.03-.073.022-.073.022-.073z",
  fill: "url(#cw)",
  opacity: 0.57
}), React.createElement("path", {
  d: "M40.395 20.9c-.007.007 0 .022.007.044.015.022.03.037.037.03s0-.023-.007-.045c-.015-.022-.03-.036-.037-.029z",
  fill: "url(#cv)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M40.372 20.951c0 .007.022.007.044-.007.023-.008.038-.022.038-.03s-.023-.007-.045.008c-.022.007-.037.022-.037.029z",
  fill: "url(#ct)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M40.395 20.929l.015.015h.022l-.015-.015h-.022z",
  fill: "url(#cs)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M40.417 20.914l-.015.015v.022l.015-.015c.007-.007.007-.022 0-.022z",
  fill: "url(#cr)",
  opacity: 0.88
}), React.createElement("path", {
  d: "M40.484 20.958c.015-.037-.007-.073-.044-.088s-.074.007-.09.044.008.073.045.088.074-.007.089-.044z",
  fill: "url(#cq)",
  opacity: 0.57
}));

var _ref166 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("radialGradient", {
  id: "cq",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(.06653 .0214 -.02144 .0667 40.414 20.935)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "ct",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.0398 .01815 -.0058 -.0127 40.414 20.935)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "bq",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(.03208 -.23589 .00693 .00094 7 20.752)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "bp",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.23932 -.02909 .00084 -.00688 6.999 20.751)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "bn",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.09158 .06292 -.00182 -.00265 6.998 20.752)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "bm",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.06393 -.0911 .00264 -.00185 6.999 20.753)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "bl",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.06273 -.00883 .0028 -.01996 6.998 20.752)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "bk",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.0135 .06105 -.01995 -.00441 6.998 20.752)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "bj",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.0231 .0159 -.00517 -.00752 6.998 20.752)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "bi",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-127.963 8.564 8.667) scale(.02826 .00906)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "bh",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(.08315 -.05714 .0576 .0838 6.998 20.752)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "bg",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.0165 -.04785 .04093 -.01412 6.833 20.633)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "bf",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(.14985 -.1556 .00441 .00425 6.833 20.634)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "be",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.1555 -.14313 .00423 -.0046 6.834 20.633)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "bc",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.0995 -.00186 .00005 -.00285 6.837 20.632)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "bb",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(.0021 -.1003 .00291 .00006 6.833 20.633)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "ba",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.04071 -.03884 .01249 -.01309 6.832 20.634)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "az",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.04217 .0371 -.01198 -.01362 6.835 20.634)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "ay",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.02512 -.0005 .00016 -.00808 6.833 20.633)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "ax",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.00069 -.02501 .0081 -.00022 6.832 20.634)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "aw",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(.09033 .00177 -.00177 .09033 6.833 20.633)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "av",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.01649 -.04783 .0409 -.0141 6.632 20.832)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "au",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(.14967 -.1554 .0044 .00425 6.631 20.833)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "at",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.15562 -.14325 .00423 -.0046 6.632 20.832)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "ar",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.09954 -.00191 .00005 -.00285 6.632 20.832)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "aq",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(.0021 -.09972 .0029 .00006 6.631 20.832)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "ap",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-136.364 7.486 9.088) scale(.05634 .01812)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "ao",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(138.68 -.612 11.666) scale(.05613 .01813)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "an",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.02512 -.0005 .00016 -.00808 6.632 20.832)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "am",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.00069 -.02501 .0081 -.00022 6.631 20.832)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "al",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(.09035 .00177 -.00177 .09035 6.632 20.832)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "ak",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.0013 -.03905 .03362 -.00113 6.93 20.937)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "aj",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(.14742 -.08274 .0023 .0041 6.93 20.936)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "ai",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.08152 -.13867 .00422 -.00248 6.93 20.935)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "ag",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-162.258 5.098 9.927) scale(.07715 .00222)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "af",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(.02408 -.07309 .00212 .0007 6.93 20.935)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "ae",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.02141 -.03788 .01225 -.00692 6.93 20.935)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "ad",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(155.474 1.19 11.22) scale(.04374 .01397)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "ac",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.0185 -.00593 .00192 -.00599 6.93 20.935)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "ab",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(.00517 -.0187 .00608 .00168 6.93 20.935)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "br",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.04672 -.03256 .02762 -.03962 7 20.753)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "eh",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.04673 -.03256 .02761 -.03963 40.482 20.752)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "eg",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(.03207 -.23588 .00694 .00094 40.483 20.752)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "ef",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.23932 -.02909 .00084 -.00688 40.482 20.751)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "ee",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.09158 .06292 -.00182 -.00265 40.482 20.752)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "ed",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.06393 -.0911 .00263 -.00185 40.482 20.752)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "ec",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.06272 -.00883 .0028 -.01996 40.482 20.752)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "ea",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.01349 .06105 -.01994 -.0044 40.482 20.752)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "dz",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.0231 .01589 -.00517 -.00752 40.479 20.756)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "dy",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.01737 -.02228 .00714 -.00557 40.482 20.752)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "dx",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(.08315 -.05714 .0576 .0838 40.482 20.752)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "dw",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.0165 -.04785 .04093 -.01412 40.316 20.633)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "dv",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(.14985 -.1556 .00441 .00425 40.316 20.634)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "du",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.1555 -.14313 .00423 -.0046 40.317 20.633)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "dt",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.0995 -.00191 .00005 -.00285 40.316 20.633)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "ds",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(.0021 -.1003 .00291 .00006 40.316 20.633)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "dr",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-136.36 24.288 2.246) scale(.05627 .01809)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "dp",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(138.67 16.267 17.92) scale(.05616 .01814)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "do",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.02512 -.0005 .00016 -.00808 40.317 20.634)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "dn",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.00069 -.02501 .0081 -.00022 40.318 20.636)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "dm",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(.09033 .00177 -.00177 .09033 40.316 20.633)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "dl",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.0165 -.04782 .0409 -.0141 40.115 20.832)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "dk",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(.14968 -.15541 .0044 .00425 40.115 20.833)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "dj",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.15562 -.14325 .00423 -.0046 40.116 20.832)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "di",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.09954 -.00206 .00006 -.00285 40.1 20.863)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "dh",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(.0021 -.09972 .0029 .00006 40.115 20.832)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "dg",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-136.364 24.227 2.385) scale(.05633 .01812)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "de",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(138.669 16.13 17.981) scale(.05612 .01813)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "dd",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.02512 -.0005 .00016 -.00808 40.115 20.832)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "dc",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.00069 -.02501 .0081 -.00022 40.115 20.832)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "db",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(.09035 .00177 -.00177 .09035 40.115 20.832)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "da",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.0013 -.03904 .03362 -.00113 40.414 20.935)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "cz",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(.14741 -.08275 .0023 .0041 40.414 20.936)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "cy",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.08152 -.13866 .00422 -.00248 40.415 20.935)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "cx",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.07348 -.0235 .00068 -.00211 40.414 20.935)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "cw",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(.02408 -.07309 .00212 .0007 40.414 20.935)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "cv",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.0214 -.03788 .01225 -.00692 40.414 20.935)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "aa",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(.06652 .0214 -.02145 .0667 6.93 20.935)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "cs",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-.0185 -.00593 .00192 -.00599 40.414 20.935)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("radialGradient", {
  id: "cr",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(.00517 -.0187 .00607 .00168 40.414 20.935)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0.002
}), React.createElement("stop", {
  stopColor: "#E8ECFF",
  offset: 0.188
}), React.createElement("stop", {
  stopColor: "#D2D9FF",
  offset: 0.429
}), React.createElement("stop", {
  stopColor: "#C4CEFF",
  offset: 0.657
}), React.createElement("stop", {
  stopColor: "#BFCAFF",
  offset: 0.857
})), React.createElement("linearGradient", {
  id: "u",
  x1: 40.315,
  x2: 40.426,
  y1: 20.781,
  y2: 20.594,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "l",
  x1: 6.831,
  x2: 7.038,
  y1: 20.781,
  y2: 20.709,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "t",
  x1: 40.315,
  x2: 40.457,
  y1: 20.781,
  y2: 20.616,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "s",
  x1: 40.315,
  x2: 40.484,
  y1: 20.781,
  y2: 20.643,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "r",
  x1: 40.315,
  x2: 40.506,
  y1: 20.781,
  y2: 20.674,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "q",
  x1: 40.315,
  x2: 40.522,
  y1: 20.781,
  y2: 20.709,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "p",
  x1: 40.315,
  x2: 40.532,
  y1: 20.781,
  y2: 20.746,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "o",
  x1: 40.315,
  x2: 40.534,
  y1: 20.781,
  y2: 20.785,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "n",
  x1: 40.315,
  x2: 40.53,
  y1: 20.781,
  y2: 20.824,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "m",
  x1: 40.315,
  x2: 40.519,
  y1: 20.781,
  y2: 20.86,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "k",
  x1: 40.315,
  x2: 40.502,
  y1: 20.781,
  y2: 20.895,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "j",
  x1: 40.315,
  x2: 40.478,
  y1: 20.781,
  y2: 20.925,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "i",
  x1: 40.315,
  x2: 40.451,
  y1: 20.781,
  y2: 20.951,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "h",
  x1: 40.315,
  x2: 40.419,
  y1: 20.781,
  y2: 20.972,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "g",
  x1: 40.315,
  x2: 40.384,
  y1: 20.781,
  y2: 20.986,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "f",
  x1: 40.315,
  x2: 40.348,
  y1: 20.781,
  y2: 20.995,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "e",
  x1: 40.315,
  x2: 40.311,
  y1: 20.781,
  y2: 20.998,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "d",
  x1: 40.315,
  x2: 40.274,
  y1: 20.781,
  y2: 20.994,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "c",
  x1: 40.315,
  x2: 40.238,
  y1: 20.781,
  y2: 20.984,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "b",
  x1: 40.315,
  x2: 40.204,
  y1: 20.781,
  y2: 20.968,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "ew",
  x1: 40.315,
  x2: 40.173,
  y1: 20.781,
  y2: 20.946,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "ev",
  x1: 40.315,
  x2: 40.146,
  y1: 20.781,
  y2: 20.919,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "eu",
  x1: 40.315,
  x2: 40.124,
  y1: 20.781,
  y2: 20.888,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "et",
  x1: 40.315,
  x2: 40.108,
  y1: 20.781,
  y2: 20.853,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "es",
  x1: 40.315,
  x2: 40.098,
  y1: 20.781,
  y2: 20.815,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "er",
  x1: 40.315,
  x2: 40.095,
  y1: 20.781,
  y2: 20.776,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "eq",
  x1: 40.315,
  x2: 40.1,
  y1: 20.781,
  y2: 20.738,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "ep",
  x1: 40.315,
  x2: 40.111,
  y1: 20.781,
  y2: 20.701,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "eo",
  x1: 40.315,
  x2: 40.128,
  y1: 20.781,
  y2: 20.667,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "en",
  x1: 40.315,
  x2: 40.151,
  y1: 20.781,
  y2: 20.636,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "el",
  x1: 40.315,
  x2: 40.179,
  y1: 20.781,
  y2: 20.61,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "ek",
  x1: 40.315,
  x2: 40.211,
  y1: 20.781,
  y2: 20.59,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "ej",
  x1: 40.315,
  x2: 40.245,
  y1: 20.781,
  y2: 20.575,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "ei",
  x1: 40.315,
  x2: 40.282,
  y1: 20.781,
  y2: 20.566,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "as",
  x1: 6.831,
  x2: 6.974,
  y1: 20.781,
  y2: 20.616,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "ah",
  x1: 6.831,
  x2: 7,
  y1: 20.781,
  y2: 20.643,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "w",
  x1: 6.831,
  x2: 7.022,
  y1: 20.781,
  y2: 20.674,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "v",
  x1: 40.315,
  x2: 40.392,
  y1: 20.781,
  y2: 20.578,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "a",
  x1: 6.831,
  x2: 7.048,
  y1: 20.781,
  y2: 20.746,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "em",
  x1: 6.831,
  x2: 7.051,
  y1: 20.781,
  y2: 20.785,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "eb",
  x1: 6.831,
  x2: 7.047,
  y1: 20.781,
  y2: 20.824,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "dq",
  x1: 6.831,
  x2: 7.035,
  y1: 20.781,
  y2: 20.86,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "df",
  x1: 6.831,
  x2: 7.018,
  y1: 20.781,
  y2: 20.895,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "cu",
  x1: 6.831,
  x2: 6.995,
  y1: 20.781,
  y2: 20.925,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "cp",
  x1: 6.831,
  x2: 6.967,
  y1: 20.781,
  y2: 20.951,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "co",
  x1: 6.831,
  x2: 6.935,
  y1: 20.781,
  y2: 20.972,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "cn",
  x1: 6.831,
  x2: 6.901,
  y1: 20.781,
  y2: 20.986,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "cm",
  x1: 6.831,
  x2: 6.865,
  y1: 20.781,
  y2: 20.995,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "cl",
  x1: 6.831,
  x2: 6.827,
  y1: 20.781,
  y2: 20.998,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "cj",
  x1: 6.831,
  x2: 6.79,
  y1: 20.781,
  y2: 20.994,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "ci",
  x1: 6.831,
  x2: 6.754,
  y1: 20.781,
  y2: 20.984,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "ch",
  x1: 6.831,
  x2: 6.72,
  y1: 20.781,
  y2: 20.968,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "cg",
  x1: 6.831,
  x2: 6.689,
  y1: 20.781,
  y2: 20.946,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "cf",
  x1: 6.831,
  x2: 6.662,
  y1: 20.781,
  y2: 20.919,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "ce",
  x1: 6.831,
  x2: 6.64,
  y1: 20.781,
  y2: 20.888,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "cd",
  x1: 6.831,
  x2: 6.624,
  y1: 20.781,
  y2: 20.853,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "cc",
  x1: 6.831,
  x2: 6.615,
  y1: 20.781,
  y2: 20.815,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "cb",
  x1: 6.831,
  x2: 6.612,
  y1: 20.781,
  y2: 20.776,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "ca",
  x1: 6.831,
  x2: 6.616,
  y1: 20.781,
  y2: 20.738,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "by",
  x1: 6.831,
  x2: 6.627,
  y1: 20.781,
  y2: 20.701,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "bx",
  x1: 6.831,
  x2: 6.645,
  y1: 20.781,
  y2: 20.667,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "bw",
  x1: 6.831,
  x2: 6.668,
  y1: 20.781,
  y2: 20.636,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "bv",
  x1: 6.831,
  x2: 6.696,
  y1: 20.781,
  y2: 20.61,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "bu",
  x1: 6.831,
  x2: 6.727,
  y1: 20.781,
  y2: 20.59,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "bt",
  x1: 6.831,
  x2: 6.762,
  y1: 20.781,
  y2: 20.575,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "bs",
  x1: 6.831,
  x2: 6.798,
  y1: 20.781,
  y2: 20.566,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "ex",
  x1: 6.664,
  x2: 6.998,
  y1: 20.784,
  y2: 20.784,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#EFF4FF",
  offset: 0.296
}), React.createElement("stop", {
  stopColor: "#E1EAFF",
  offset: 0.673
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "bz",
  x1: 6.831,
  x2: 6.872,
  y1: 20.781,
  y2: 20.568,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "bo",
  x1: 6.831,
  x2: 6.909,
  y1: 20.781,
  y2: 20.578,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "bd",
  x1: 6.831,
  x2: 6.943,
  y1: 20.781,
  y2: 20.594,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "ck",
  x1: 6.831,
  x2: 6.835,
  y1: 20.781,
  y2: 20.564,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "y",
  x1: 40.315,
  x2: 40.319,
  y1: 20.781,
  y2: 20.564,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "x",
  x1: 40.315,
  x2: 40.356,
  y1: 20.781,
  y2: 20.568,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#FAFBFF",
  offset: 0.325
}), React.createElement("stop", {
  stopColor: "#EBF1FF",
  offset: 0.723
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})), React.createElement("linearGradient", {
  id: "z",
  x1: 40.148,
  x2: 40.482,
  y1: 20.784,
  y2: 20.784,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#EFF4FF",
  offset: 0.296
}), React.createElement("stop", {
  stopColor: "#E1EAFF",
  offset: 0.673
}), React.createElement("stop", {
  stopColor: "#DCE7FF",
  offset: 1
})));

var SvgDontSunglassesImg = function SvgDontSunglassesImg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    fill: "none",
    width: 48,
    height: 48,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDontSunglassesImg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dont-sunglasses-img.20054822.svg";
export { ForwardRef as ReactComponent };